module.exports = __webpack_public_path__ + "static/media/phytocore_white.f36d810d.png";